import produce from 'immer';

const INITIAL_STATE = {
  result: [],
  loading: false,
};

export default function reportDailyHour(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@reports/DAILY_HOUR/REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@reports/DAILY_HOUR/SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.result = action.payload.data;
      });

    case '@reports/DAILY_HOUR/FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.result = [];
      });

    default:
      return state;
  }
}
